(function () {
  'use strict';

  var script = document.currentScript || document.querySelector('script[data-dbx-aftersell-brand]');
  var stylesheet = script && script.getAttribute('data-stylesheet');
  if (!stylesheet) return;

  var key = '__dbxAftersellBrand';
  if (window[key]) {
    window[key].refresh(stylesheet);
    return;
  }

  var host;
  var root;
  var retry;
  var attempts = 0;
  var queued = false;
  var notificationQueued = false;
  var labelsQueued = false;
  var styleId = 'dbx-aftersell-brand-stylesheet';
  var observer = new MutationObserver(function () {
    if (!host || !host.isConnected || document.getElementById('aftersell-pdp-upsell') !== host || (root && !root.getElementById(styleId))) schedule();
  });
  var offerObserver = new MutationObserver(notifyRecommendations);
  var controlsObserver = new MutationObserver(scheduleCarouselLabels);

  function labelCarouselArrows() {
    if (!root || !host || !host.isConnected) return;
    root.querySelectorAll('button.carousel-button.left, button.carousel-button.right').forEach(function (button) {
      if ((button.getAttribute('aria-label') || '').trim() ||
          (button.getAttribute('aria-labelledby') || '').trim() ||
          (button.getAttribute('title') || '').trim() ||
          (button.textContent || '').trim()) return;
      button.setAttribute('aria-label', button.classList.contains('left') ? 'Previous products' : 'Next products');
    });
  }

  function scheduleCarouselLabels() {
    if (labelsQueued) return;
    labelsQueued = true;
    window.requestAnimationFrame(function () {
      labelsQueued = false;
      labelCarouselArrows();
    });
  }

  function notifyRecommendations() {
    if (notificationQueued || !document.querySelector('product-recommendations[data-exclude-aftersell="true"]')) return;
    notificationQueued = true;
    window.requestAnimationFrame(function () {
      notificationQueued = false;
      document.dispatchEvent(new CustomEvent('dbx:aftersell:change'));
    });
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      mount();
    });
  }

  function mount() {
    window.clearTimeout(retry);
    observer.disconnect();
    offerObserver.disconnect();
    controlsObserver.disconnect();
    var nextHost = document.getElementById('aftersell-pdp-upsell');
    if (nextHost !== host) attempts = 0;
    host = nextHost;
    root = host && host.shadowRoot;
    var scope = document.getElementById('main-content') || document.querySelector('main') || document.body;
    if (scope) observer.observe(scope, { childList: true, subtree: true });

    if (!root) {
      notifyRecommendations();
      if (host && attempts < 40) {
        attempts += 1;
        retry = window.setTimeout(mount, 250);
      }
      return;
    }

    attempts = 0;
    var link = root.getElementById(styleId);
    if (!link) {
      link = document.createElement('link');
      link.id = styleId;
      link.rel = 'stylesheet';
      link.href = stylesheet;
      root.appendChild(link);
    } else if (link.getAttribute('href') !== stylesheet) {
      link.setAttribute('href', stylesheet);
    }
    observer.observe(root, { childList: true });
    labelCarouselArrows();
    controlsObserver.observe(root, { childList: true, subtree: true });
    if (document.querySelector('product-recommendations[data-exclude-aftersell="true"]')) {
      offerObserver.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'disabled', 'aria-disabled', 'href']
      });
      offerObserver.observe(host, {
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
      });
      notifyRecommendations();
    }
  }

  function refresh(nextStylesheet) {
    if (typeof nextStylesheet === 'string' && nextStylesheet) stylesheet = nextStylesheet;
    attempts = 0;
    schedule();
  }

  window[key] = { refresh: refresh };
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);
  window.addEventListener('resize', notifyRecommendations);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
}());
